export const vFocus = (el: HTMLElement) => {
    el.focus();
};
